import React from "react";
import { useHistory } from "react-router-dom";
import Alert from "../../UI/Alert/Alert";

const BillableModal = ({ billable, nonbillable, onClose, error, clearError }) => {
    const history = useHistory();

    const { messageType, isError, errorMessage } = error;
    const handleRedirect = () => {
        onClose();
        history.push("/dashboard/campaign");
    };

    return (
        <div className="modal-overlay" onClick={handleRedirect} style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999
        }}>
            <div className="p-4" onClick={(e) => e.stopPropagation()} style={{
                backgroundColor: "#fff",
                borderRadius: ".8rem",
                width: "90%",
                maxWidth: "400px",
                boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
                position: "relative"
            }}>
                {isError && (
                    <div style={{width:"95%"}}>
                        <Alert type={messageType} >
                            {errorMessage}
                        </Alert>

                    </div>
                )}
                <button className="close-btn" onClick={handleRedirect} style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    background: "none",
                    border: "none",
                    fontSize: "30px",
                    cursor: "pointer"
                }}>×</button>
                {/* <div >
                    <p><strong>Billable:</strong> <span>{billable}</span></p>
                    <p><strong>Non-Billable:</strong> <span>{nonbillable}</span></p>
                </div> */}
                <div>
                    <button className="btn-success w-100" onClick={handleRedirect} style={{ color: "#fff", padding: "10px 20px", border: "none", borderRadius: "4px", cursor: "pointer" }}>Go to Campaign Report</button>
                </div>
            </div>
        </div>
    );
};

export default BillableModal;
